import { Pipe, PipeTransform } from '@angular/core';
import { StepStatusEnum } from '../../enums/step-status';
@Pipe({
  name: 'parallelStepStatus',
  standalone: true,
})
export class ParallelStepStatusPipe implements PipeTransform {
  transform(value: string | null): string {
    switch (value) {
      case StepStatusEnum.COMPLETED:
        return 'bg-success-50 text-success-700';
      case StepStatusEnum.INPROGRESS:
        return 'bg-warning-50 text-warning-700';
      case StepStatusEnum.SKIPPED:
      case StepStatusEnum.NOT_STARTED:
        return 'bg-neutral-50 text-neutral-700';
      case StepStatusEnum.REJECTED:
      case StepStatusEnum.SENT_FORWARD:
      case StepStatusEnum.SENT_BACK:
        return 'bg-destructive-50 text-destructive-700';
      case StepStatusEnum.ON_HOLD:
        return 'bg-neutral-100 text-neutral-700';
      default:
        return 'bg-neutral-100 text-neutral-700';
    }
  }
}
